"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateTerminalOnline = exports.useCreateTerminalOnline = exports.useFetchTerminalOnline = void 0;
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const terminalOnlineAction_1 = require("./terminalOnlineAction");
const useFetchTerminalOnline = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const fetchTerminalOnlineLoading = (0, react_redux_1.useSelector)((state) => state['terminalOnline/fetch'].loading);
    const fetchTerminalOnlineData = (0, react_redux_1.useSelector)((state) => state['terminalOnline/fetch'].data);
    const fetchTerminalOnlineError = (0, react_redux_1.useSelector)((state) => state['terminalOnline/fetch'].error);
    const fetchTerminalOnline = (terminalOnlineFetchPayload) => __awaiter(void 0, void 0, void 0, function* () {
        let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
        if (!userLogged) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, terminalOnlineAction_1.fetch)(terminalOnlineFetchPayload));
    });
    return {
        fetchTerminalOnlineLoading,
        fetchTerminalOnlineData,
        fetchTerminalOnlineError,
        fetchTerminalOnline
    };
};
exports.useFetchTerminalOnline = useFetchTerminalOnline;
const useCreateTerminalOnline = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const createTerminalOnlineLoading = (0, react_redux_1.useSelector)((state) => state['terminalOnline/create'].loading);
    const createTerminalOnlineData = (0, react_redux_1.useSelector)((state) => state['terminalOnline/create'].data);
    const createTerminalOnlineError = (0, react_redux_1.useSelector)((state) => state['terminalOnline/create'].error);
    const createTerminalOnline = (terminalCreatePayload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, terminalOnlineAction_1.create)(terminalCreatePayload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error('Error in creating terminal online');
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        createTerminalOnlineLoading,
        createTerminalOnlineData,
        createTerminalOnlineError,
        createTerminalOnline
    };
};
exports.useCreateTerminalOnline = useCreateTerminalOnline;
const useUpdateTerminalOnline = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const updateTerminalOnlineLoading = (0, react_redux_1.useSelector)((state) => state['terminalOnline/update'].loading);
    const updateTerminalOnlineData = (0, react_redux_1.useSelector)((state) => state['terminalOnline/update'].data);
    const updateTerminalOnlineError = (0, react_redux_1.useSelector)((state) => state['terminalOnline/update'].error);
    const updateTerminalOnline = (terminalCreatePayload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, terminalOnlineAction_1.update)(terminalCreatePayload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error('Error in updating terminal online');
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        updateTerminalOnlineLoading,
        updateTerminalOnlineData,
        updateTerminalOnlineError,
        updateTerminalOnline
    };
};
exports.useUpdateTerminalOnline = useUpdateTerminalOnline;
